/*
 * Authors: mariushirjanu
 * Created: 24/06/2019
 * Upgraded: 22/02/2023
 */
import { HttpDataService } from '../../../shared/http/http-data.service';

import { Injectable } from '@angular/core';
import { IPricesRequest, IPricesResponse } from './price-cart.service';

export interface IOrderFee {
  acslFee:number;
  lamFee:number;
}

@Injectable()
export class PriceCartDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /***/
  }

  public getOrderFees(webshopId:number, countryId:number, orderId:number, currency:string):Promise<IOrderFee> {
    return this.httpDataService.doGET(
      `rest/orderentry/webshops/${webshopId}/countries/${countryId}/fees`,
      {
        orderId,
        currency
      },
      undefined,
      'Error loading fees'
    );
  }

  public loadPrices(webshopId:number, countryId:number, priceRequestData:IPricesRequest):Promise<IPricesResponse>{
    return this.httpDataService.doPUT(
      `rest/orderentry/webshops/${webshopId}/countries/${countryId}/prices`,
      undefined,
      priceRequestData,
      undefined,
      'Error loading Prices',
      'punchoutLoadPrices'
    );
  }
}